import {apiFetch} from 'src/api/fetch'

import {type DispatchReport, dispatchReportSchema} from './schemas'

export async function getDispatchReport(reportDate: string): Promise<DispatchReport> {
    const params = new URLSearchParams({report_date: reportDate})
    const raw = await apiFetch<unknown>(`/dispatch/report?${params.toString()}`)
    return dispatchReportSchema.parse(raw)
}
